export default __webpack_public_path__ + "static/media/2F.fed361a4.jpg";